import { render, staticRenderFns } from "./couponLayout1.vue?vue&type=template&id=4c99d9b8&"
import script from "./couponLayout1.vue?vue&type=script&lang=ts&"
export * from "./couponLayout1.vue?vue&type=script&lang=ts&"
import style0 from "./couponLayout1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports